// extracted by mini-css-extract-plugin
export default {"v-hackster":"var(--hackster)","v-lake":"var(--lake)","v-sky":"var(--sky)","v-standardBorderRadius":"4px","label":"radio__label__g_aCy","checked":"radio__checked__mdEYG"};